import RequestManager from "src/requests/RequestManager";
import { Player, Team } from "../interfaces";
import { isMockDataActive, roster, team as mockTeam } from "../mockData";
import { RosterTask, TeamTask } from "../tasks";
import { parsePlayer, parseTeam } from "../utils";

// Se usa en VCardJugador
export default async function getPlayer(teamId: string, playerId: string): Promise<{
    player: Player,
    relatedPlayers: Player[],
    coach: Player,
    team: Team
}> {
    const rosterTask = new RosterTask(teamId);
    const teamTask = new TeamTask(teamId);
    let rosterResult;
    let team;
    if(isMockDataActive) {
        rosterResult = roster;
        playerId = roster.players[0].id;
        team = mockTeam;
    } else {
        rosterResult = await RequestManager.addRequest(rosterTask);
        const teamResult = await RequestManager.addRequest(teamTask);
        team = parseTeam(teamResult.team || {});
    }
    const players = (rosterResult.players || []).map((ply: any) => parsePlayer(ply));
    const coaches = (rosterResult.coaches) || []
    const coach = parsePlayer(coaches.length > 0 ? coaches[0] : {});
    const relatedPlayers = players.filter((player: Player) => player.id !== playerId);
    const player = players.filter((player: Player) => player.id === playerId)[0];

    return {
        player,
        relatedPlayers,
        coach,
        team
    }
    
}


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getPlayer.ts